module.exports = __webpack_public_path__ + "playw.svg?72deaf2da1e954fd086cf43065c2ffd5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/playw.svg
// module id = 13
// module chunks = 0